import { getElements, ifSelectorExist } from "./utils";

export const accordionFAQ = () => {

	const accordions = document.querySelectorAll(".accordion-faq-item");

	const openAccordion = (accordion) => {
		const content = accordion.querySelector(".accordion-faq-item-content");
		accordion.classList.add("active");
		content.style.maxHeight = content.scrollHeight + "px";
	};

	const closeAccordion = (accordion) => {
		const content = accordion.querySelector(".accordion-faq-item-content");
		accordion.classList.remove("active");
		content.style.maxHeight = null;
	};

	accordions.forEach((accordion) => {
		const intro = accordion.querySelector(".accordion-faq-item-header");
		const content = accordion.querySelector(".accordion-faq-item-content");

		intro.onclick = () => {
			if (content.style.maxHeight) {
				closeAccordion(accordion);
			} else {
				accordions.forEach((accordion) => closeAccordion(accordion));
				openAccordion(accordion);
			}
		};
	});
};

export const targetFaqItems = () => {
	const faqItems = getElements('.faq-item');
    
	if (ifSelectorExist(faqItems)) {
		faqItems.forEach(function(item) {
			item.addEventListener('click', function() {
				const targetId = item.getAttribute('faq-target');
				const targetElement = document.getElementById(targetId);
				
				if (ifSelectorExist(targetElement)) {
					window.scrollTo(0, targetElement.offsetTop - 150);
				}
			});
		});	
	}
};